import React from "react";

class Loader extends React.Component {
  render() {
    return (
      <svg className="svg" viewBox="25 25 50 50">
        <circle r="20" cy="50" cx="50"></circle>
      </svg>
    );
  }
}

export default Loader;
